export { registrationPersonalDataFields, registrationBillingFields } from './registration';
export { default as loginFields } from './login';
export { default as addressFields } from './address';
export { default as addressTwoLinesFields } from './addressTwoLines';
export { default as requestCompanyChange } from './requestCompanyChange';
export { default as deliveryFields } from './delivery';
export { default as notesFields } from './notes';
export { default as userDataFields } from './userData';
export { default as passwordFields } from './password';
export { default as contactFields } from './contact';
export { default as newsletterFields } from './newsletter';
export { default as forgottenPwFields } from './forgottenPw';
export { default as recoverPwFields } from './recoverPw';
export { default as inquiryFields } from './inquiry';



// WEBPACK FOOTER //
// ./src/formFields/index.tsx